import { EDIS } from "../actionTypes";

const initialState = {
    edisSummaryDetails: {},
    isLoading: false
}

const edisReducer = (state = initialState, action) => {
    switch(action.type) {
        case EDIS.EDIS_SUMMARY_DETAILS_SUCCESS:
            return {
                ...state,
                edisSummaryDetails: action.payload
            }
        case EDIS.EDIS_SUMMARY_DETAILS_FAILURE:
            return {
                ...state,
                edisSummaryDetails: action.payload
            }
        case EDIS.GENERATE_TPIN_SUCCESS: {
            return {
                ...state,
                tpin: action.payload
            }
        }
        case EDIS.GENERATE_TPIN_FAILURE: {
            return {
                ...state,
                tpin: action.payload       
            }
        }
        case EDIS.UPDATE_EDIS_IS_LOADING: {
            return {
                ...state,
                isLoading: action.payload
            }
        }
        default:
            return state;
    }
}

export default edisReducer;